class CartItem extends Component {
    constructor(el) {
        super(el);
        this.counter = this.$find('[data-counter]');
        this.remove = this.$find('[data-remove]');
        this.addEventListeners();
    }

    updateCart(e) {
        e.preventDefault();
        const href = e.currentTarget.getAttribute('href');
        EventBus.getInstance().dispatchEvent('orderUpdateStepCart', (href ? {href: href} : {}));
    }

    addEventListeners() {
        this.counter && this.counter.addEventListener('change', e => this.updateCart(e));
        this.remove && this.remove.addEventListener('click', e => this.updateCart(e));
    }
}
